var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9965,
    cy: 10.9965,
    r: 10.9965,
    fill: "#12B973"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84571 13.1797L15.6961 7.32923C15.8342 7.19116 15.9953 7.12213 16.1794 7.12213C16.3635 7.12213 16.5245 7.19116 16.6626 7.32923C16.8007 7.46729 16.8697 7.63124 16.8697 7.82108C16.8697 8.01091 16.8007 8.17487 16.6626 8.31293L10.3289 14.6638C10.1909 14.8019 10.0298 14.8709 9.84571 14.8709C9.66163 14.8709 9.50055 14.8019 9.36249 14.6638L6.39412 11.6955C6.25606 11.5574 6.18991 11.3935 6.19566 11.2036C6.20141 11.0138 6.27332 10.8498 6.41138 10.7118C6.54945 10.5737 6.7134 10.5047 6.90323 10.5047C7.09307 10.5047 7.25702 10.5737 7.39508 10.7118L9.84571 13.1797Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.448d147321a85ab53499b82f3dc96687.svg";
export { ForwardRef as ReactComponent };